/**
 * Find related control items based on safeguard ID
 * @param {string} safeguardId - Safeguard ID to search for
 * @param {Array} combinedItemsArray - Array of combined items
 * @returns {Array} - Related control items
 */
function findRelatedControlItems(safeguardId, combinedItemsArray) {
	if (!safeguardId || !combinedItemsArray || !Array.isArray(combinedItemsArray)) {
		return [];
	}

	return combinedItemsArray.filter(item => {
		// Check if the item has a safeguard ID that matches or is related
		if (item.safeguardid && item.safeguardid.S) {
			return item.safeguardid.S === safeguardId;
		}
		return false;
	});
}

// Export for use in other modules
if (typeof module !== 'undefined' && module.exports) {
	module.exports = findRelatedControlItems;
} else if (typeof window !== 'undefined') {
	window.findRelatedControlItems = findRelatedControlItems;
}
